import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { Icon } from "../components/Icon";
import { Label } from "../components/Label";
import { Tooltip } from "../components/Tooltip";
import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import * as React from "react";
export const radioStyles = cva(cn("s-aspect-square s-rounded-full s-border s-transition s-duration-200 s-ease-in-out", "s-border-border-dark dark:s-border-primary-500", "s-bg-background dark:s-bg-background-night", "s-text-foreground dark:s-text-foreground-night", "s-flex s-items-center s-justify-center", "focus-visible:s-outline-none focus-visible:s-ring-2 focus-visible:s-ring-offset-2 focus-visible:s-ring-ring", "hover:s-border-highlight hover:s-bg-highlight-50 dark:hover:s-bg-highlight-100-night hover:dark:s-border-highlight", "disabled:s-cursor-not-allowed disabled:s-opacity-50 disabled:s-border-border-dark disabled:dark:s-border-border-dark-night disabled:s-bg-background dark:disabled:s-bg-background-night", "checked:s-ring-0", "checked:s-bg-highlight-500 dark:checked:s-bg-highlight-500-night"), {
    variants: {
        size: {
            xs: "s-h-4 s-w-4",
            sm: "s-h-5 s-w-5",
        },
    },
    defaultVariants: {
        size: "xs",
    },
});
export const radioIndicatorStyles = cva("s-bg-primary dark:s-bg-primary-night s-flex s-items-center s-justify-center s-rounded-full", {
    variants: {
        size: {
            xs: "s-h-2 s-w-2",
            sm: "s-h-2.5 s-w-2.5",
        },
    },
    defaultVariants: {
        size: "xs",
    },
});
const RadioGroup = React.forwardRef(({ className, ...props }, ref) => {
    return (React.createElement(RadioGroupPrimitive.Root, { className: cn("s-grid s-gap-2", className), ...props, ref: ref }));
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;
const RadioGroupItem = React.forwardRef(({ tooltipMessage, className, icon, size, label, labelProps, id, ...props }, ref) => {
    const renderIcon = (visual, extraClass = "") => (React.createElement(Icon, { visual: visual, size: "sm", className: cn("s-text-foreground dark:s-text-foreground-night", extraClass) }));
    const item = (React.createElement(RadioGroupPrimitive.Item, { ref: ref, id: id, className: cn(radioStyles({ size }), className), ...props },
        React.createElement(RadioGroupPrimitive.Indicator, { className: radioIndicatorStyles({ size }) })));
    const wrappedItem = (React.createElement("div", { className: "s-flex s-w-full s-items-center s-gap-2" },
        tooltipMessage ? (React.createElement(Tooltip, { trigger: item, label: tooltipMessage })) : (item),
        icon && renderIcon(icon),
        React.createElement(Label, { htmlFor: id, ...labelProps, className: cn("s-cursor-pointer", props.disabled && "s-cursor-not-allowed s-opacity-70", labelProps === null || labelProps === void 0 ? void 0 : labelProps.className) }, label)));
    return React.createElement("div", { className: "s-group s-w-full" }, wrappedItem);
});
const RadioGroupCustomItem = React.forwardRef(({ className, size, customItem, iconPosition = "center", children, id, ...props }, ref) => {
    const item = (React.createElement(RadioGroupPrimitive.Item, { ref: ref, id: id, className: cn(radioStyles({ size }), className), ...props },
        React.createElement(RadioGroupPrimitive.Indicator, { className: radioIndicatorStyles({ size }) })));
    return (React.createElement("div", { className: cn("s-flex s-w-full s-flex-col", className, `s-items-${iconPosition}`) },
        React.createElement("div", { className: "s-flex s-w-full s-items-center s-gap-2" },
            item,
            customItem),
        children));
});
export { RadioGroup, RadioGroupCustomItem, RadioGroupItem };
//# sourceMappingURL=RadioGroup.js.map